import React from 'react';
import ProjectPipeline from './ProjectPipeline';

function App() {
  return (
    <div className="App">
      <ProjectPipeline />
    </div>
  );
}

export default App;